<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="comm.flightCommId > 0; else addTitle">Edit Communication</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Communication Information</legend>
        <p>
          <mat-form-field class="edit-comm">
            <input matInput
                   placeholder="Type *"
                   formControlName="type"
                   [(ngModel)]="comm.service">
          </mat-form-field>
          <mat-form-field class="edit-comm">
            <input matInput
                   placeholder="Call Sign "
                   formControlName="callSign"
                   [(ngModel)]="comm.radioCall">
          </mat-form-field>
        </p>
      </fieldset>
      <fieldset class="fieldset-container">
        <legend>Frequency Information</legend>
        <p>
          <mat-form-field class="edit-comm">
            <input matInput
                   placeholder="Frequency"
                   formControlName="frequency"
                   [(ngModel)]="comm.frequency">
          </mat-form-field>
          <mat-form-field class="edit-comm">
            <mat-select placeholder="Mode *" [(value)]="selectedFreqMode" name="freqMode" formControlName="freqMode">
              <mat-option value="Duplex">Duplex</mat-option>
              <mat-option value="Transmit">Transmit</mat-option>
              <mat-option value="Receive">Receive</mat-option>
              <mat-option value="Unknown">Unknown</mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-comm">
            <input #phone matInput
                   placeholder="Phone"
                   formControlName="phone"
                   [(ngModel)]="selectedPhone"
                   maxlength="14"
                   (blur)="phoneFieldBlur('phone')"
                   (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
          </mat-form-field>
          <mat-form-field class="edit-comm">
            <input matInput
                   placeholder="Sector/Comments"
                   formControlName="sector"
                   [(ngModel)]="comm.sector">
          </mat-form-field>
        </p>
        <mat-expansion-panel *ngIf="!isNew" (opened)="newFrequencyPanelOpened()" (closed)="newFrequencyPanelClosed()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              New Frequency
            </mat-panel-title>
            <mat-panel-description>
              &nbsp;&nbsp;{{newFrequencyText}}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div id="newFrequency">
            <p>
              <mat-form-field class="edit-comm">
                <input matInput
                       placeholder="Frequency"
                       formControlName="newFrequency"
                       [(ngModel)]="selectedNewFrequency">
              </mat-form-field>
              <mat-form-field class="edit-comm">
                <mat-select placeholder="Mode *" [(value)]="selectedNewFreqMode" name="newFreqMode" formControlName="newFreqMode">
                  <mat-option value="Duplex">Duplex</mat-option>
                  <mat-option value="Transmit">Transmit</mat-option>
                  <mat-option value="Receive">Receive</mat-option>
                  <mat-option value="Unknown">Unknown</mat-option>
                </mat-select>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="edit-comm">
                <input #phone matInput
                       placeholder="Phone"
                       formControlName="newPhone"
                       [(ngModel)]="selectedNewPhone"
                       maxlength="14"
                       (blur)="phoneFieldBlur('phone')"
                       (keyup)="phoneFieldKeyUp($event, 'phone', phone)">
              </mat-form-field>
              <mat-form-field class="edit-comm">
                <input matInput
                       placeholder="Sector/Comments"
                       formControlName="newSector"
                       [(ngModel)]="selectedNewSector">
              </mat-form-field>
            </p>
          </div>
        </mat-expansion-panel>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Communication
</ng-template>
